<fieldset class="form-group col-md-4">
	<legend>Configuration</legend>
	<div class="dx-field">
		<div class="dx-field-label" style="width:80%">Active links always on top</div>
		<div class="dx-field-value" style="width:20%">
			<dx-switch [(value)]="enableLiveColumnRefresh"></dx-switch>
		</div>
	</div>
</fieldset>
<div *ngIf="listObservable | async as data; else loading">
	<dx-data-grid [dataSource]="data" [allowColumnResizing]="true" [allowColumnReordering]="true" [wordWrapEnabled]="true">
		<dxo-selection [showCheckBoxesMode]="'none'"></dxo-selection>
		<dxo-filter-row [visible]="true"></dxo-filter-row>

		<dxi-column dataField="isLinkCurrentlyRunning" caption="Is running" cellTemplate="isLinkRunningTemplate" sortOrder="asc" [width]="110"></dxi-column>
		<dxi-column dataField="livestatus" [width]="200" caption="Status" cellTemplate="statusTemplate"></dxi-column>
		<dxi-column dataField="companyIdentifier"></dxi-column>
		<dxi-column dataField="dName"></dxi-column>
		<dxi-column dataField="linkName"></dxi-column>
		<dxi-column dataField="nextExecutionDate" caption="Next scheduled execution date" cellTemplate="nextExecutionDate"></dxi-column>
		<dxi-column dataField="linkExpiryDate" caption="Days left" cellTemplate="expiryDateCell"></dxi-column>
		<dxi-column dataField="lastLogDate" sortOrder="desc" dataType="datetime" caption="Last execution date"></dxi-column>
		<!-- <dxi-column dataField="toDName"></dxi-column> -->
		<dxi-column dataField="matchingLinkIssues" [width]="200" caption="Link issue report" cellTemplate="warnings"></dxi-column>
		<dxi-column dataField="id" caption="Navigate to link" cellTemplate="navigateToLink"></dxi-column>

		<div *dxTemplate="let data of 'expiryDateCell'">
			<span *ngIf="!getDaysTillExpiry(data.value).expired">
				{{ getDaysTillExpiry(data.value).daysLeft }} days till expiry
			</span>
			<span *ngIf="getDaysTillExpiry(data.value).expired" style="color: red;">
				Expired {{ getDaysTillExpiry(data.value).daysLeft }} days ago
			</span>
		</div>

		<div *dxTemplate="let data of 'navigateToLink'">
			<button type="button" class="btn btn-primary" (click)="navigateToLink(data.value)">Go to link</button>
		</div>

		<div *dxTemplate="let data of 'nextExecutionDate'">
			<span [ngStyle]="{'color': isExpired(data.value) ? 'red' : 'black'}">
				{{ data.value | date: 'mediumDate' }}
			</span>
		</div>

		<div *dxTemplate="let data of 'warnings'">
			<ng-container *ngIf="data.value && data.value.length > 0">
				<div style="color: red" (click)="OpenLinkIssueScreen(data.value)">{{data.value.length}} Issue found with this link </div>
			</ng-container>
		</div>

		<div *dxTemplate="let data of 'isLinkRunningTemplate'">
			<ng-container *ngIf="data.value">
				<div class="led-green" title="Online"></div>
			</ng-container>
			<ng-container *ngIf="!data.value">
				<div class="led-red" title="Offline"></div>
			</ng-container>
		</div>

		<div *dxTemplate="let data of 'statusTemplate'">
			<div [ngClass]="{'alert-success': data.data.statusColor==linkStatusCode.Success, 'alert-info': data.data.statusColor==linkStatusCode.Info, 'alert-danger': data.data.statusColor==linkStatusCode.Danger}" class="alert">{{ data.value }}</div>
		</div>
	</dx-data-grid>
</div>

<ng-template #loading>Loading....</ng-template>

<appshell-admin-link-overview-link-issue-modal></appshell-admin-link-overview-link-issue-modal>
